import React, { useCallback, useEffect, useRef, useState } from "react";
import CreateCategory from "../components/categoryManagement/CreateCategory";
import exportPic from "../assets/images/export.png";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  categoryStatusChanged,
  getCategory,
} from "../features/slices/categoryManagement";
import { useSelector } from "react-redux";
import TableSkeleton from "../components/TableSkeleton";
import moment from "moment/moment";
import CommonPagination from "../components/CommonPagination";
import ExportToExcel from "../components/ExportToExcel";
import EditCategory from "../components/categoryManagement/EditCategory";
import DeleteModal from "../components/DeleteModal";
import { toastService } from "../utils/toastify";
import { canPerformAction } from "../utils/denyAccess";
const initialState = {
  currentPage: 1,
  searchQuery: "",
  status: "",
  addCategoryModal: false,
  editCategoryModal: false,
  deleteCategoryModal: false,
};
const CategoryManagement = () => {
  const [iState, setUpdateState] = useState(initialState);
  const {
    searchQuery,
    status,
    addCategoryModal,
    editCategoryModal,
    deleteCategoryModal,
  } = iState;
  const [categoryData, setCategoryData] = useState({});
  const [page, setPage] = useState(1);
  const categoryRef = useRef();
  const dispatch = useDispatch();
  const { category, loading } = useSelector((state) => state.category);
  useEffect(() => {
    dispatch(getCategory({ page }));
    window.scrollTo(0, 0);
  }, [page]);
  console.log({ category });
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleShowAddCategory = () => {
    setUpdateState({ ...iState, addCategoryModal: true });
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (searchQuery && searchQuery?.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(getCategory({ search: searchQuery?.trim() })).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value };
    dispatch(categoryStatusChanged(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getCategory({ page })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  const handleEditShow = (e, res) => {
    setCategoryData(res);
    setUpdateState((prev) => ({
      ...prev,
      editCategoryModal: true,
    }));
  };
  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteCategoryModal: false,
    }));
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getCategory({ page }));
  };
  const handleDelete = useCallback(async () => {
    try {
      const { _id: categoryId } = categoryData || {};
      const res = await dispatch(
        categoryStatusChanged({ id: categoryId, status: "DELETED" })
      );

      if (res?.payload?.code === 200) {
        toastService.success("Category deleted successfully");
        dispatch(getCategory());
        hanldeClose();
      } else {
        toastService.error(res?.payload?.message);
      }
    } catch (error) {
      toastService.error("An error occurred while deleting the category");
    }
  }, [
    categoryData,
    dispatch,
    hanldeClose,
    toastService,
    getCategory,
    categoryStatusChanged,
  ]);
  const handleDeleteModal = (res) => {
    setCategoryData(res);
    setUpdateState((prev) => ({
      ...prev,
      deleteCategoryModal: true,
    }));
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="FilterArea">
            {canPerformAction("Category") && (
              <div className="TitleBox m-0">
                <label>&nbsp;</label>
                <a className="TitleLink" onClick={handleShowAddCategory}>
                  <i className="fa-solid fa-plus" /> Add New Category
                </a>
              </div>
            )}
          </div>
          <div className="Small-Wrapper">
            <div className="NewFilter">
              <div className="SearchBox">
                <input
                  type="search"
                  className="SearchInput"
                  placeholder="Search here by ID, Name, or Others"
                  name="searchQuery"
                  value={searchQuery}
                  onChange={(e) => handleSearch(e)}
                />
                <span>
                  <i className="fa fa-search" />
                </span>
              </div>
              <div className="Actions">
                <button className="Button Cancel ml-2" onClick={handleReset}>
                  <i className="fa fa-refresh" />
                </button>
                <ExportToExcel ref={categoryRef} fileName="category" />
              </div>
            </div>
            <div className="TableList">
              <table className="table-hover" ref={categoryRef}>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Category Type</th>
                    <th>Category Id</th>
                    <th>Category Name</th>
                    <th>Created On</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <TableSkeleton
                      length={category?.result?.[0]?.paginationData?.length}
                    />
                  ) : (
                    category?.result?.[0]?.paginationData.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1 + (page - 1) * 10}</td>
                          <td>{res?.categoryType}</td>
                          <td>
                            {" "}
                            <div className="fw500">{res?.category_number}</div>
                          </td>
                          <td>
                            <div className="fw500">{res?.categoryName}</div>
                          </td>
                          <td>
                            {" "}
                            {moment(res?.createdAt).format("MM-DD-YYYY")}
                          </td>
                          <td>
                            <span
                              className={`${
                                res?.status == "ACTIVE" ? "Green" : "Red"
                              }`}
                            >
                              {res?.status == "ACTIVE"
                                ? "Available"
                                : "Blocked"}
                            </span>
                          </td>
                          <td>
                            <div className="Actions">
                              {canPerformAction("Category") && (
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={res?.status == "ACTIVE"}
                                    name="status"
                                    onChange={(e) => handleStatus(e, res?._id)}
                                  />
                                  <span className="slider" />
                                </label>
                              )}
                              <Link
                                to="/topicDetails"
                                state={res?._id}
                                className="Eyes"
                              >
                                <i className="fa-regular fa-eye" />
                              </Link>
                              {canPerformAction("Category") && (
                                <>
                                  <a
                                    className="Edit"
                                    onClick={(e) => handleEditShow(e, res)}
                                  >
                                    <i className="fa-regular fa-pen-to-square" />
                                  </a>
                                  <a
                                    className="Delete"
                                    onClick={() => handleDeleteModal(res)}
                                  >
                                    <i className="fa-regular fa-trash-can" />
                                  </a>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <div className="Pagination">
              <p>
                Showing {(page - 1) * 10 + 1} to{" "}
                {category?.result?.[0]?.paginationData?.length +
                  (page - 1) * 10}{" "}
                of {category?.result?.[0]?.totalCount?.[0]?.count} results
              </p>
              <div className="PaginationRight">
                {category?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                  <CommonPagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={
                      category?.result?.[0]?.totalCount?.[0]?.count || 0
                    }
                    pageRangeDisplayed={4}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {addCategoryModal && <CreateCategory setUpdateState={setUpdateState} />}
      {editCategoryModal && (
        <EditCategory
          setUpdateState={setUpdateState}
          categoryData={categoryData}
        />
      )}
      {deleteCategoryModal && (
        <DeleteModal
          handleDelete={handleDelete}
          hanldeClose={hanldeClose}
          statement={"category"}
        />
      )}
    </>
  );
};

export default CategoryManagement;
